import {
  fetchBillingLedger,
  type BillingLedgerResponse,
  type LedgerQueryParams
} from "../api/billingApi";
import { useApiQuery } from "../../../hooks/useApiQuery";
import { useCallback, useMemo } from "react";

export function useBillingLedger(params: LedgerQueryParams) {
  const queryFn = useCallback(
    (token: string) =>
      fetchBillingLedger(token, {
        workspaceId: params.workspaceId,
        limit: params.limit,
        offset: params.offset
      }),
    [params.limit, params.offset, params.workspaceId]
  );

  const result = useApiQuery<BillingLedgerResponse>({
    queryFn
  });

  return useMemo(() => {
    const entries = result.data?.entries ?? [];
    const total = result.data?.total ?? 0;
    return {
      data: entries,
      total,
      isLoading: result.isLoading,
      error: result.error,
      refresh: result.refresh
    };
  }, [result.data, result.error, result.isLoading, result.refresh]);
}
